/*
============================
CUSTOM AJAX FUNCTIONS
============================
*/

$(function () {}); //END
